import { render, staticRenderFns } from "./DeleteMultipleTariffs.vue?vue&type=template&id=7658688a&"
import script from "./DeleteMultipleTariffs.vue?vue&type=script&lang=ts&"
export * from "./DeleteMultipleTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardText,VDataTable})
